import maxPageSize from '../maxPageSize'

const requireValidPaginationParameters = (pageIndex: number, pageSize: number): void => {
  if (pageIndex < 0) throw Error('pageIndex must be greater than or equal to 0')
  if (pageSize < 1) throw Error('pageSize must be greater than or equal to 1')
  if (pageSize > maxPageSize) throw Error(`pageSize must be less than or equal to ${maxPageSize}`)
}

export default requireValidPaginationParameters
